import AutoComplete from "../autocomplete";
import { ui, dtos } from "../common"

interface Props {
    customerIds: string[];
    onChanged(newCustomerIds: string[])
}

interface Row {
    id: string;
}

export default function CustomersList(props: Props) {
    const rows = props.customerIds.map((id) => ({
        id: id,
    }))

    function addRow() {
        props.onChanged([...props.customerIds, ""])
    }

    function removeRow(idx:number) {
        props.customerIds.splice(idx, 1);
        props.onChanged([...props.customerIds]);
    }

    function setRow(idx:number, id:string) {
        props.customerIds[idx] = id;
        props.onChanged([...props.customerIds]);
    }

    return <div>
        <ui.Table showHeader={false} dataSource={rows} rowKey={(r, i) => r.id || i.toString()} pagination={false}>
            <ui.Table.Column title="Customer" render={(value, row: Row, idx) => <div>
                <AutoComplete placeholder="Select a customer" type={dtos.ValueTypes.Customer} value={row.id} onChanged={id => setRow(idx, id)} />
            </div>} />
            <ui.Table.Column title="" render={(value, row:Row, idx) => <div>
                <ui.Popconfirm title="Remove this customer?" onConfirm={() => removeRow(idx)}><ui.Button size="small"><i className="fa fa-trash" /></ui.Button></ui.Popconfirm>
            </div>} />
        </ui.Table>
        <ui.Button.Group style={{marginTop:8}}>
            <ui.Button onClick={addRow}>Add Customer</ui.Button>
        </ui.Button.Group>
    </div>
}